import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { useUser } from '@hooks/useUser';
import { redirects } from '@lib/redirects';
import { BUILDER_PAGE } from '@packages/builder/BuilderBox/data';
import { createMemo } from '@packages/react';
import { Route } from '@packages/router';
import React from 'react';
import { Redirect } from 'react-router';
import { TABS as CustomerTabs } from './List/views/customer/tabs';
import { TABS as DefaultTabs } from './List/views/default/tabs';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
    Review: AsyncPageRender(() => pageModule(import('./Review'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
    Customize: AsyncPageRender(() => pageModule(import('./Customize'))),
    SelectProduct: AsyncPageRender(() => pageModule(import('./SelectProduct'))),
};

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: ListTabRedirect
 * @date:  30.01.2020
 * @time:  17:39
 * Used to ensure a nice and logic redirect from /builder/list to /builder/:tab/list
 * since tabs differ by user type.
 */
const ListTabRedirect = createMemo(
    (): any => {
        const user$ = useUser();
        const isCustomer = !user$ || user$.$is('customer');

        return <Redirect to={`/builder/${isCustomer ? CustomerTabs[0] : DefaultTabs[0]}/list`} />;
    },
    {
        displayName: 'ListTabRedirect',
    },
);

function Router() {
    return (
        <>
            {redirects({
                '/builder/:id/customize': ({ id }) => `/builder/${id}/customize/${BUILDER_PAGE.PRODUCT_OPTIONS}`,
            })}

            <Route name={'Builder.ListLogic'} exact path={'/builder/list'} component={ListTabRedirect} />

            <Route
                name={'Builder.SelectProduct'}
                exact
                path={'/builder/select/:category?/:product?'}
                component={ProtectedRoute(routes$.SelectProduct, { required: null })}
            />
            <Route
                name={'Builder.Review'}
                exact
                path={'/builder/:id/customize/review'}
                component={ProtectedRoute(routes$.Review, { required: null })}
            />
            <Route
                name={'Builder.Customize'}
                exact
                path={'/builder/:id/customize/:tab'}
                component={ProtectedRoute(routes$.Customize, { required: null })}
            />

            <Route
                name={'Builder.Item.View'}
                exact
                path={'/builder/:id/view'}
                component={ProtectedRoute(routes$.View)}
            />
            <Route
                name={'Builder.Item.Edit'}
                exact
                path={'/builder/:id/edit'}
                component={ProtectedRoute(routes$.Edit)}
            />

            <Route name={'Builder.List'} exact path={'/builder/:tab/list'} component={ProtectedRoute(routes$.List)} />
        </>
    );
}

export default Router;
